

















































import Vue from 'vue';
import Component from 'vue-class-component';
import WebApiMessage from '@/core/messages/WebApiMessage.vue';
import Api from '@/project/http/Api.service';

@Component({
    components: { WebApiMessage }
})
export default class ForgotPasswordPanel extends Vue {
    email: string = '';
    emailSent = false;
    busy = false;

    goBack() {
        this.$emit('go-back');
    }

    close() {
        this.$emit('close');
    }

    async submit() {
        try {
            this.busy = true;
            await Api.authentication.requestPasswordReset(this.email, 'requestpasswordreset');
            this.emailSent = true;
        } catch (err) {
            // Ok, validation-messages will be shown
        } finally {
            this.busy = false;
        }
    }
}
